// routeConfig.js
import { SlCalender } from 'react-icons/sl';
import { GiFarmer } from 'react-icons/gi';
import { TbReportAnalytics } from 'react-icons/tb';
import { FaTableList } from 'react-icons/fa6';
import { MdOutlineDashboard, MdOutlineSpaceDashboard } from 'react-icons/md';

// Define base routes available to all clients
export const baseRoutes = {
  dashboardnew: {
    name: 'Centralised Dashboard',
    icon: MdOutlineDashboard,
    path: 'dashboardAnalytics',
    active: true
  },
  dashboard: {
    name: 'Markfed Dashboard',
    icon: TbReportAnalytics,
    path: 'dashboard/dashboard_beam',
    active: true
  },
  reports: {
    name: 'Reports',
    icon: TbReportAnalytics,
    active: true,
    children: [
      {
        name: 'State Procurement Report',
        icon: TbReportAnalytics,
        path: 'state_procurement_dashboard_report_fcs',
        active: true
      },
      {
        name: 'Milling Dispatch Report',
        icon: TbReportAnalytics,
        path: 'milling_dispatch_dashboard_report_fcs',
        active: true
      },
      {
        name: 'Farmer Records',
        icon: TbReportAnalytics,
        path: 'farmer_dashboard_records_fcs',
        active: true
      },
      {
        name: 'Infrastructure Records',
        icon: TbReportAnalytics,
        path: 'infrastructure_dashboard_report_fcs',
        active: true
      },
      {
        name: 'Bonus Summary Report',
        icon: TbReportAnalytics,
        path: 'bonus_summary_fcs_dashboard',
        active: true
      }
    ]
  }
};

// Define client-specific route configurations
export const clientRoutes = {
  AMBUJAFOUNDATION: {
    additionalRoutes: ['comparison', 'villageLevel', 'farmLevel']
  },
  MRV: {
    additionalRoutes: [
      'comparison',
      'villageLevel',
      'farmerReport',
      'weatherReport',
      'dashboardAnalytics',
      'plotOverlay',
      'farmLevel',
      'cropInfectionReport',
      'smsManagement',
      'cropInfectionRuleReport'
    ]
  },
  RPLC: {
    additionalRoutes: ['comparison', 'plotOverlay', 'farmLevel']
  },
  SESTA: {
    additionalRoutes: ['comparison']
  },
  TNSMRV: {
    additionalRoutes: ['farmLevel']
  }
};

// Define additional routes that can be added based on client
export const additionalRoutes = {
  villageLevel: {
    name: 'Village Level Data',
    icon: FaTableList,
    path: 'village',
    active: true
  },
  farmerReport: {
    name: 'Farmer Report',
    icon: TbReportAnalytics,
    path: 'farmerReport',
    active: true
  },
  weatherReport: {
    name: 'Weather Forecast Report',
    icon: TbReportAnalytics,
    path: 'weatherReport',
    active: true
  },
  dashboardAnalytics: {
    name: 'Dashboard Analytics',
    icon: TbReportAnalytics,
    path: 'dashboardAnalytics',
    active: true
  },
  plotOverlay: {
    name: 'Plot Overlay & Comparison',
    icon: GiFarmer,
    path: 'plotoverlay',
    active: true
  },
  farmLevel: {
    name: 'Farm-level Report',
    icon: TbReportAnalytics,
    path: 'farmlevelReport',
    active: true
  },
  smsManagement: {
    name: 'SMS Management',
    icon: TbReportAnalytics,
    path: 'smsmanagement',
    active: true
  },
  comparison: {
    name: 'Comparison',
    icon: GiFarmer,
    path: 'comparison',
    active: true
  },
  // cropInfection: {
  //   name: 'Crop Infection Rule',
  //   icon: GiFarmer,
  //   path: 'cropInfection',
  //   active: true
  // },
  cropInfectionReport: {
    name: 'Crop Infection Report',
    icon: GiFarmer,
    path: 'cropInfection/report',
    active: true
  },
  cropInfectionRuleReport: {
    name: 'Crop Infection Rule Report',
    icon: GiFarmer,
    path: 'cropInfection/rules/report',
    active: true
  }
};
